// extracted by mini-css-extract-plugin
export var scrollArea = "_pe-0";